import RoleGate from '../../components/RoleGate'
import { ROLES } from '../../app/navigation'
import { strings as S } from './strings'

/**
 * Every programme screen, for content managers only — the role both slices require
 * (`RequireRole("ContentManagers")`). See components/RoleGate.jsx.
 */
export default function ContentManagersOnly({ children }) {
  return (
    <RoleGate role={ROLES.ContentManagers} title={S.title}>
      {children}
    </RoleGate>
  )
}
